<template>
  <kbd class="keyboard" :active="isActive">{{ label }}</kbd>
</template>

<script>
export default {
  props: {
    value: String,
    label: {
      type: String,
      default() {
        return this.value
      },
    },
  },
  data() {
    return {
      keys: {},
    }
  },
  computed: {
    isActive() {
      return this.keys[this.value.toTitleCase()]
    },
  },
  methods: {
    onKey(ev) {
      this.$set(this.keys, ev.key, ev.type === 'keydown')
    },
  },
  mounted() {
    document.addEventListener('keydown', this.onKey)
    document.addEventListener('keyup', this.onKey)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKey)
    document.removeEventListener('keyup', this.onKey)
  },
}
</script>

<style lang="scss">
.keyboard {
  --kbd-offset: 3px;

  display: inline-block;
  background-color: rgba(black, 0.1);
  color: $dark;
  padding: 0px 5px;
  border-radius: 3px;
  border: 1px solid rgba(black, 0.2);
  box-shadow: 0 var(--kbd-offset) 0 0 rgba(black, 0.2);
  position: relative;

  transition: 100ms ease-out;
  transition-property: box-shadow, transform;

  will-change: box-shadow, transform;

  text-transform: uppercase;

  &[active='true'] {
    transform: translateY(var(--kbd-offset));
    box-shadow: 0 0 0 0 transparent;
  }
}
</style>
